import { Stack } from '@landler/component-library';

import { PLOT_MEDIA_FILE_TYPE, PlotOverviewMediaFile } from '@/api/rest/resources/types/plot';
import {
  Carousel,
  MediaAudio,
  MediaImage,
  MediaVideo,
} from '@/pages/shared/projects/pages/project/pages/sustainableProduction/pages/plot/pages/components/MediaFile';

import { ApprovalPill } from './ApprovalPill';
import { DeleteMediaFileButton, EditMediaFileButton } from './MediaFilesActionButtons';

export const MediaFiles = ({
  mediaFiles,
  plotOverviewId,
}: {
  mediaFiles: PlotOverviewMediaFile[];
  plotOverviewId?: string;
}) => {
  const files = {
    images: mediaFiles.filter((file) => file.type === PLOT_MEDIA_FILE_TYPE.IMAGE),
    videos: mediaFiles.filter((file) => file.type === PLOT_MEDIA_FILE_TYPE.VIDEO),
    audios: mediaFiles.filter((file) => file.type === PLOT_MEDIA_FILE_TYPE.AUDIO),
  };

  const hasFiles = Object.values(files).flat().length > 0;

  if (!hasFiles) {
    return null;
  }

  return (
    <Stack spacing={10} className='my-6'>
      {files.images.length > 0 && (
        <Carousel files={files.images} type={PLOT_MEDIA_FILE_TYPE.IMAGE} className='items-start'>
          {files.images.map((image) => (
            <div key={image.id}>
              <ApprovalPill isApproved={image.is_approved} className='mb-2' />
              <MediaImage key={image.id} {...image} />
              <Stack direction='row' spacing={2}>
                <DeleteMediaFileButton mediaFileId={image.id} />
                {plotOverviewId && <EditMediaFileButton mediaFile={image} plotOverviewId={plotOverviewId} />}
              </Stack>
            </div>
          ))}
        </Carousel>
      )}
      {files.videos.length > 0 && (
        <Carousel files={files.videos} type={PLOT_MEDIA_FILE_TYPE.VIDEO} className='items-start'>
          {files.videos.map((video) => (
            <div key={video.id}>
              <ApprovalPill isApproved={video.is_approved} className='mb-2' />
              <MediaVideo key={video.id} {...video} />
              <Stack direction='row' spacing={2}>
                <DeleteMediaFileButton mediaFileId={video.id} />
                {plotOverviewId && <EditMediaFileButton mediaFile={video} plotOverviewId={plotOverviewId} />}
              </Stack>
            </div>
          ))}
        </Carousel>
      )}
      {files.audios.length > 0 && (
        <Carousel files={files.audios} type={PLOT_MEDIA_FILE_TYPE.AUDIO} className='items-start'>
          {files.audios.map((audio) => (
            <div key={audio.id}>
              <ApprovalPill isApproved={audio.is_approved} className='mb-2' />
              <MediaAudio key={audio.id} {...audio} />
              <Stack direction='row' spacing={2}>
                <DeleteMediaFileButton mediaFileId={audio.id} className='mt-2' />
                {plotOverviewId && (
                  <EditMediaFileButton mediaFile={audio} className='mt-2' plotOverviewId={plotOverviewId} />
                )}
              </Stack>
            </div>
          ))}
        </Carousel>
      )}
    </Stack>
  );
};
